import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

export const ERROR_IDS = ['termsError', 'exceededError', 'digitsError',
  'minimumError', 'leadZeroError'];

export const getWarningData = (id, values, maxMiles, minMiles) => {
  const ERROR_DEFAULT_MESSAGES = {
    termsError: 'Please read and agree to the Terms & Conditions.',
    exceededError: `Please select an amount up to ${maxMiles} miles.`,
    minimumError: `Please select an amount greater than ${minMiles - 1} miles.`,
    digitsError: 'Please use only numbers.',
    leadZeroError: 'The value entered cannot begin with 0.',
  };

  const result = {
    defaultMessage: ERROR_DEFAULT_MESSAGES[id],
  };
  if (values) {
    result.values = values;
  }
  return result;
};

export const InputWarning = ({
  id, values, maxMiles, minMiles,
}) => {
  const data = getWarningData(id, values, maxMiles, minMiles);
  if (id && data.defaultMessage) {
    return (
      <span className="color-status-text-critical margin-1-b text-align-left" aria-live="assertive" role="alert">
        <FormattedMessage
          id={id}
          defaultMessage={data.defaultMessage}
          values={data.values}
        />
      </span>
    );
  }
  return null;
};

InputWarning.propTypes = {
  id: PropTypes.string,
  values: PropTypes.shape({}),
};

InputWarning.defaultProps = {
  id: null,
  values: null,
};

export default InputWarning;
